import React from "react";

export default function Admin() {
    return (
        <div>
            <h1>Estamos en Admin.</h1>
        </div>
    );
}